import { useEffect } from "react";
import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, ClipboardList, Calendar, Bell, LogOut } from "lucide-react";

const sidebarLinks = [
  { label: "Overview", to: "/dashboard", icon: LayoutDashboard },
  { label: "Schedule", to: "/dashboard/schedule", icon: Calendar },
  { label: "Notifications", to: "/dashboard/notifications", icon: Bell },
];

export default function DashboardLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("dd_token");

  useEffect(() => {
    if (!token) navigate("/dashboard/login", { replace: true });
  }, [token, navigate]);

  if (!token) return null;

  const logout = () => {
    localStorage.removeItem("dd_token");
    navigate("/dashboard/login");
  };

  return (
    <div className="min-h-screen bg-[#0B110E] flex" data-testid="dashboard-layout">
      {/* Sidebar */}
      <aside className="w-56 bg-[#070D0A] border-r border-[#1F2937] flex flex-col shrink-0 sticky top-0 h-screen">
        <div className="p-4 border-b border-[#1F2937]">
          <Link to="/dashboard" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#D95D39] rounded-sm flex items-center justify-center font-black text-white text-sm">DD</div>
            <span className="font-bold text-[#F8FAFC] text-sm tracking-tight">Dashboard</span>
          </Link>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {sidebarLinks.map((l) => {
            const active = location.pathname === l.to || (l.to === "/dashboard" && location.pathname.startsWith("/dashboard/jobs"));
            return (
              <Link key={l.to} to={l.to} data-testid={`sidebar-${l.label.toLowerCase()}`} className={`flex items-center gap-2.5 px-3 py-2.5 rounded-sm text-sm font-medium transition-colors duration-150 ${active ? "bg-[#D95D39]/10 text-[#D95D39]" : "text-[#9CA3AF] hover:text-[#F8FAFC] hover:bg-[#1E293B]/30"}`}>
                <l.icon className="w-4 h-4" />
                {l.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-3 border-t border-[#1F2937]">
          <Link to="/" className="flex items-center gap-2.5 px-3 py-2 text-[#64748B] text-xs hover:text-[#9CA3AF] transition-colors duration-150 mb-1">
            <ClipboardList className="w-3.5 h-3.5" /> View Public Site
          </Link>
          <button onClick={logout} data-testid="sidebar-logout" className="flex items-center gap-2.5 px-3 py-2 text-[#64748B] text-xs hover:text-[#DC2626] transition-colors duration-150 w-full">
            <LogOut className="w-3.5 h-3.5" /> Sign Out
          </button>
        </div>
      </aside>
      {/* Main */}
      <main className="flex-1 min-h-screen overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
